// @flow

import React, { Component } from 'react';
import i18n from 'app/common/lib/i18n';
import hoverable, { type hoverHandlersType } from 'app/common/lib/react/hoverable';
import { Box, Flyout, Icon, Text } from 'gestalt';

type Props = {
  hoverHandlers: hoverHandlersType,
  isHovering: boolean,
};

export class ClaimedWebsiteMark extends Component<Props> {
  claimedWebsiteMark: ?HTMLElement;

  render() {
    const {
      isHovering,
      hoverHandlers: { onMouseOver, onMouseLeave },
    } = this.props;
    return (
      <Box
        display="inlineBlock"
        marginRight={2}
        tabIndex={0}
        onFocus={onMouseOver}
        onBlur={onMouseLeave}
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
        position="relative"
      >
        <div
          style={{ display: 'inline-block' }}
          ref={(c) => {
            this.claimedWebsiteMark = c;
          }}
        >
          <Icon
            accessibilityLabel={isHovering ? '' : i18n._('Claimed website', 'Claimed website icon')}
            color="darkGray"
            icon="globe-checked"
            inline
            size={16}
          />
        </div>
        {isHovering && (
          <Flyout
            anchor={this.claimedWebsiteMark}
            color="darkGray"
            idealDirection="left"
            onDismiss={() => {}}
            shouldFocus={false}
            size="sm"
          >
            <Box column={12} padding={3}>
              <Text color="white" overflow="normal" size="xs">
                {i18n._('This website has been claimed', 'Tooltip for claimed website.')}
              </Text>
            </Box>
          </Flyout>
        )}
      </Box>
    );
  }
}

export default hoverable(ClaimedWebsiteMark);
